import { useState, useEffect } from 'react'
import { Map, NavigationControl } from 'maplibre-gl'
import { getHomePosition } from '../../utils/configQueries'

const maps = {}

export const useMapEngine = (containerRef) => {
  const [map, setMap] = useState()
  const containerId =
    typeof containerRef === 'string' ? containerRef : containerRef?.current?.id
  const { center, zoom, pitch } = getHomePosition()
  useEffect(
    () => () => {
      if (
        typeof containerRef !== 'string' &&
        maps[containerId]?.engine &&
        !containerRef.current
      ) {
        maps[containerId]?.engine.remove()
        maps[containerId] = null
      }
    },
    [containerRef, containerId]
  )
  useEffect(() => {
    if (containerId && !maps[containerId]) {
      const engine = new Map({
        container: containerId,
        style: {
          version: 8,
          sources: {
            'raster-tiles': {
              type: 'raster',
              tiles: [
                'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}'
              ],
              tileSize: 256,
              attribution: 'CEPAL ECLAC v 0.18'
            }
          },
          glyphs: 'http://fonts.openmaptiles.org/{fontstack}/{range}.pbf',
          layers: [
            {
              id: 'simple-tiles',
              type: 'raster',
              source: 'raster-tiles',
              minzoom: 0,
              maxzoom: 19
            }
          ]
        },
        //      bounds: new MapEngine.LngLatBounds([-140, -60], [-34, 34]),
        center,
        zoom,
        pitch
      })
      engine.addControl(
        new NavigationControl({ visualizePitch: true }),
        'top-left'
      )
      maps[containerId] = { engine, isReady: false }
    }

    if (maps[containerId] && !maps[containerId].isReady) {
      maps[containerId].engine.on('load', () => {
        setMap(maps[containerId].engine)
        maps[containerId].isReady = true
      })
    } else {
      setMap(maps[containerId]?.engine)
    }
  }, [containerId, center, zoom, pitch])

  return [map]
}
